import * as t from 'io-ts'

import * as tv from '@espoon-voltti/ts-libs/lib/io-ts-types'

export const Event = t.type({
  name: t.union([t.string, t.null]),
  location: t.union([t.string, t.null]),
  startDate: t.union([tv.localDateFromString, t.null]),
  endDate: t.union([tv.localDateFromString, t.null])
})
export type Event = t.TypeOf<typeof Event>
